import makeStyles from "@material-ui/core/styles/makeStyles";
import { MuiTheme } from "theme";

export const PPS_ROW_HEIGHT = 84;

export default makeStyles((theme: MuiTheme) => ({
  ppTableCell: {
    padding: "4px 16px",
    lineHeight: "normal",
    fontSize: 13,
    minHeight: PPS_ROW_HEIGHT,
    height: PPS_ROW_HEIGHT,
    [theme.breakpoints.down("sm")]: {
      height: 100
    }
  },
  actions: {
    textAlign: "right",
    color: "inherit",
    paddingLeft: 24
  },
  icon: {
    fill: "#eee"
  },
  iconActive: {
    fill: theme.palette.secondary.dark
  },
  hidden: {
    display: "none"
  }
}));
